/**
 * fleetFilters — filtres de la vue « Ma flotte » (retour apprenant : ajouter
 * des filtres catégorie / utilisé ou non …). Fonctions pures, testables.
 */
export const FLEET_USAGE_OPTIONS = [
  { id: 'all', label: 'Tous' },
  { id: 'mission', label: 'En mission' },
  { id: 'idle', label: 'Disponibles' },
  { id: 'unavailable', label: 'Indisponibles' },
];

export const FLEET_OWNERSHIP_OPTIONS = [
  { id: 'all', label: 'Tous' },
  { id: 'owned', label: 'Achetés' },
  { id: 'leased', label: 'Leasing' },
  { id: 'used', label: 'Occasion' },
];

export const FLEET_ENGINE_OPTIONS = [
  { id: 'all', label: 'Toutes' },
  { id: 'diesel', label: 'Diesel' },
  { id: 'electric', label: 'Électrique' },
];

export const DEFAULT_FLEET_FILTERS = { tier: 'all', usage: 'all', ownership: 'all', engine: 'all' };

export function vehicleUsage(v) {
  if (v.status === 'active' || v.status === 'returning' || v.assignedContractId) return 'mission';
  if (v.status === 'idle') return 'idle';
  return 'unavailable';
}

export function filterVehicles(vehicles = [], f = DEFAULT_FLEET_FILTERS) {
  return vehicles.filter((v) => {
    if (f.tier !== 'all' && String(v.tier || 1) !== String(f.tier)) return false;
    if (f.usage !== 'all' && vehicleUsage(v) !== f.usage) return false;
    if (f.ownership === 'leased' && !v.isLeased) return false;
    if (f.ownership === 'used' && !v.isUsed) return false;
    if (f.ownership === 'owned' && (v.isLeased || v.isUsed)) return false;
    if (f.engine !== 'all' && (v.engineType || 'diesel') !== f.engine) return false;
    return true;
  });
}

export const isFleetFilterActive = (f) => Object.keys(DEFAULT_FLEET_FILTERS).some((k) => f[k] !== 'all');
